import axios from "../../axios";

import moment from "../../moment";

import * as apis from "../../apis";
import * as errors from "../../errors"
import * as infos from "../../infos"

import {notifyError, notifyInfo, notifySuccess} from "../../toast-notifications";
import {goToStep, SHIFT_STEP} from "./ui";
import {changeForm} from "./reservation";


// GET RESTAURANT SETTINGS
export const GET_RESTAURANT_SETTINGS_REQUEST = "GET_RESTAURANT_SETTINGS_REQUEST";
export const GET_RESTAURANT_SETTINGS_SUCCESS = "GET_RESTAURANT_SETTINGS_SUCCESS";
export const GET_RESTAURANT_SETTINGS_ERROR = "GET_RESTAURANT_SETTINGS_ERROR";

export const getRestaurantSettingsRequest = () => {
    return {
        type: GET_RESTAURANT_SETTINGS_REQUEST,
        loading: true
    };
};
export const getRestaurantSettingsSuccess = (restaurantSettings) => {
    return {
        type: GET_RESTAURANT_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        restaurantSettings
    };
};
export const getRestaurantSettingsError = (error) => {
    return {
        type: GET_RESTAURANT_SETTINGS_ERROR,
        loading: false,
        error
    };
};
export const getRestaurantSettings = () => {
    return dispatch => {
        dispatch(getRestaurantSettingsRequest());
        axios.get(apis.GET_RESTAURANT_SETTINGS_API)
            .then(response => {
                dispatch(getRestaurantSettingsSuccess(response.data[0]));
            })
            .catch(error => {
                dispatch(getRestaurantSettingsError(errors.GET_RESTAURANT_SETTINGS_ERROR));
                notifyError(errors.GET_RESTAURANT_SETTINGS_ERROR);
            });
    };
};

// GET DEFAULT SHIFTS
export const GET_DEFAULT_SHIFTS_REQUEST = "GET_DEFAULT_SHIFTS_REQUEST";
export const GET_DEFAULT_SHIFTS_SUCCESS = "GET_DEFAULT_SHIFTS_SUCCESS";
export const GET_DEFAULT_SHIFTS_ERROR = "GET_DEFAULT_SHIFTS_ERROR";

export const getDefaultShiftsRequest = () => {
    return {
        type: GET_DEFAULT_SHIFTS_REQUEST,
        loading: true
    };
};
export const getDefaultShiftsSuccess = (defaultShifts) => {
    return {
        type: GET_DEFAULT_SHIFTS_SUCCESS,
        loading: false,
        error: null,
        defaultShifts
    };
};
export const getDefaultShiftsError = (error) => {
    return {
        type: GET_DEFAULT_SHIFTS_ERROR,
        loading: false,
        error
    };
};
export const getDefaultShifts = () => {
    return dispatch => {
        dispatch(getDefaultShiftsRequest());
        axios.get(apis.GET_DEFAULT_SHIFTS_API)
            .then(response => {
                dispatch(getDefaultShiftsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getDefaultShiftsError(errors.GET_DEFAULT_SHIFTS_ERROR));
                notifyError(errors.GET_DEFAULT_SHIFTS_ERROR);
            });
    };
};

// GET CLOSED DAYS
export const GET_CLOSED_DAYS_REQUEST = "GET_CLOSED_DAYS_REQUEST";
export const GET_CLOSED_DAYS_SUCCESS = "GET_CLOSED_DAYS_SUCCESS";
export const GET_CLOSED_DAYS_ERROR = "GET_CLOSED_DAYS_ERROR";

export const getClosedDaysRequest = () => {
    return {
        type: GET_CLOSED_DAYS_REQUEST,
        loading: true
    };
};
export const getClosedDaysSuccess = (closedDays) => {
    return {
        type: GET_CLOSED_DAYS_SUCCESS,
        loading: false,
        error: null,
        closedDays
    };
};
export const getClosedDaysError = (error) => {
    return {
        type: GET_CLOSED_DAYS_ERROR,
        loading: false,
        error
    };
};
export const getClosedDays = () => {
    return dispatch => {
        dispatch(getClosedDaysRequest());
        axios.get(apis.GET_CLOSED_DAYS_API)
            .then(response => {
                dispatch(getClosedDaysSuccess(response.data));
            })
            .catch(error => {
                dispatch(getClosedDaysError(errors.GET_CLOSED_DAYS_ERROR));
                notifyError(errors.GET_CLOSED_DAYS_ERROR);
            });
    };
};

// RESET SHIFTS
export const RESET_SHIFTS = "RESET_SHIFTS"

export const resetShifts = (notify= false) => {
    return dispatch => {
        dispatch({type: RESET_SHIFTS});
        if (notify) {
            notifyInfo(infos.RESET_SHIFTS_INFO);
        }
    };
};

// SHIFTS DAYS
export const GET_SHIFTS_REQUEST = "GET_SHIFTS_REQUEST";
export const GET_SHIFTS_SUCCESS = "GET_SHIFTS_SUCCESS";
export const GET_SHIFTS_ERROR = "GET_SHIFTS_ERROR";

export const getShiftsRequest = () => {
    return {
        type: GET_SHIFTS_REQUEST,
        loading: true
    };
};
export const getShiftsSuccess = (shifts, month = null) => {
    return {
        type: GET_SHIFTS_SUCCESS,
        loading: false,
        error: null,
        shifts,
        month
    };
};
export const getShiftsError = (error) => {
    return {
        type: GET_SHIFTS_ERROR,
        loading: false,
        error
    };
};
export const getShifts = (month, year) => {
    return (dispatch, getState) => {
        dispatch(getShiftsRequest());

        const data = { month, year };
        const dataKey = `${month}-${year}`;

        const prevShifts = getState().settingsReducer.shifts;           // Shifts in store.
        const shiftsMonths = getState().settingsReducer.shiftsMonths;   // List of month-year which shifts were fetched.    

        if (shiftsMonths.has(dataKey)) {
            dispatch(getShiftsSuccess(prevShifts));
        }
        else {
            axios.post(apis.GET_SHIFTS_API, data)
                .then(response => {
                    const newShifts = response.data;
                    dispatch(getShiftsSuccess({...prevShifts, ...newShifts}, dataKey));
                })
                .catch(error => {
                    dispatch(getShiftsError(errors.GET_SHIFTS_ERROR));
                    notifyError(errors.GET_SHIFTS_ERROR);
                });
        }
    };
};

// OPENING HOURS
export const GET_OPENING_HOURS_REQUEST = "GET_OPENING_HOURS_REQUEST";
export const GET_OPENING_HOURS_SUCCESS = "GET_OPENING_HOURS_SUCCESS";
export const GET_OPENING_HOURS_ERROR = "GET_OPENING_HOURS_ERROR";

export const getOpeningHoursRequest = () => {
    return {
        type: GET_OPENING_HOURS_REQUEST,
        loading: true
    };
};
export const getOpeningHoursSuccess = (openingHours) => {
    return {
        type: GET_OPENING_HOURS_SUCCESS,
        loading: false,
        error: null,
        openingHours
    };
};
export const getOpeningHoursError = (error) => {
    return {
        type: GET_OPENING_HOURS_ERROR,
        loading: false,
        error
    };
};
export const getOpeningHours = () => {
    return dispatch => {
        dispatch(getOpeningHoursRequest());

        axios.get(apis.GET_OPENING_HOURS_API)
            .then(response => {
                dispatch(getOpeningHoursSuccess(response.data));
            })
            .catch(error => {
                dispatch(getOpeningHoursError(errors.GET_OPENING_HOURS_ERROR));
                notifyError(errors.GET_OPENING_HOURS_ERROR);
            });
    };
};

// GET MAX SEATS
export const GET_MAX_SEATS_REQUEST = "GET_MAX_SEATS_REQUEST";
export const GET_MAX_SEATS_SUCCESS = "GET_MAX_SEATS_SUCCESS";
export const GET_MAX_SEATS_ERROR = "GET_MAX_SEATS_ERROR";

export const getMaxSeatsRequest = () => {
    return {
        type: GET_MAX_SEATS_REQUEST,
        loading: true
    };
};
export const getMaxSeatsSuccess = (maxSeats) => {
    return {
        type: GET_MAX_SEATS_SUCCESS,
        loading: false,
        error: null,
        maxSeats
    };
};
export const getMaxSeatsError = (error) => {
    return {
        type: GET_MAX_SEATS_ERROR,
        loading: false,
        error
    };
};
export const getMaxSeats = () => {
    return dispatch => {
        dispatch(getMaxSeatsRequest());
        axios.get(apis.GET_MAX_SEATS_API)
            .then(response => {
                dispatch(getMaxSeatsSuccess(response.data["max_seats"]));
            })
            .catch(error => {
                dispatch(getMaxSeatsError(errors.GET_MAX_SEATS_ERROR));
                notifyError(errors.GET_MAX_SEATS_ERROR);
            });
    };
};

// CHECK AVAILABILITY
export const CHECK_AVAILABILITY_REQUEST = "CHECK_AVAILABILITY_REQUEST";
export const CHECK_AVAILABILITY_SUCCESS = "CHECK_AVAILABILITY_SUCCESS";
export const CHECK_AVAILABILITY_ERROR = "CHECK_AVAILABILITY_ERROR";

export const checkAvailabilityRequest = () => {
    return {
        type: CHECK_AVAILABILITY_REQUEST,
        loading: true
    };
};
export const checkAvailabilitySuccess = (available) => {
    return {
        type: CHECK_AVAILABILITY_SUCCESS,
        loading: false,
        error: null,
        available
    };
};
export const checkAvailabilityError = (error) => {
    return {
        type: CHECK_AVAILABILITY_ERROR,
        loading: false,
        error
    };
};
export const checkAvailability = (seats, start_time) => {
    return dispatch => {
        dispatch(checkAvailabilityRequest());
        const data = {
            seats: seats,
            start_time: start_time
        }
        axios.post(apis.CHECK_AVAILABILITY_API, data)
            .then(response => {
                dispatch(checkAvailabilitySuccess(response.data));
                if (response.data.available) {
                    notifySuccess("C'est valide!");
                } else {
                    dispatch(changeForm(null, {name: "start_time_time", value: ""}))
                    dispatch(changeForm(null, {name: "start_time_date", value: ""}))
                    dispatch(resetShifts());
                    dispatch(goToStep(SHIFT_STEP));
                    notifyInfo(infos.CHECK_AVAILABILITY_FAILED_INFO)
                }
            })
            .catch(error => {
                dispatch(checkAvailabilityError(errors.CHECK_AVAILABILITY_ERROR));
                notifyError(errors.CHECK_AVAILABILITY_ERROR);
            });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/settings.js